import ErrorOutline from "@mui/icons-material/ErrorOutline";

import { makeSvgIcon } from "./svg-icon";

export const ErrorOutlineIcon = makeSvgIcon(
  ErrorOutline,
  (theme) => theme.palette.error.main
);

export default ErrorOutlineIcon;
